(() => {
  if (window.akbarDiaryPlaybackLoaded) return;
  window.akbarDiaryPlaybackLoaded = true;

  const getScope = (wrapper) => wrapper.closest('[data-akbar-diary-scope], [id^="gallery-"]');

  const mountVideo = (wrapper) => {
    const template = wrapper.querySelector('template[data-akbar-deferred-video]');
    if (!template) return wrapper.querySelector('video');
    const fragment = template.content.cloneNode(true);
    const video = fragment.querySelector('video');
    if (!video) return null;
    wrapper.insertBefore(fragment, template);
    template.remove();
    return video;
  };

  function bind(wrapper) {
    if (wrapper.dataset.playbackBound) return;
    const button = wrapper.querySelector('.video-play-btn');
    if (!button) return;
    wrapper.dataset.playbackBound = 'true';
    let video = wrapper.querySelector('video');
    let frameRequest;
    const baseLabel = button.getAttribute('aria-label') || 'Play video';
    const setState = state => {
      wrapper.dataset.playbackState = state;
      button.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
      const stateLabel = state === 'loading' ? `${baseLabel} — Loading` : state === 'error' ? `${baseLabel} — Tap to retry` : baseLabel;
      button.setAttribute('aria-label', stateLabel);
    };
    const reveal = () => {
      if (!video || video.paused) return;
      wrapper.dataset.frameReady = 'true';
      button.classList.add('hidden');
      setState('playing');
    };
    const reset = (failed = false) => {
      if (frameRequest !== undefined && video?.cancelVideoFrameCallback) video.cancelVideoFrameCallback(frameRequest);
      button.classList.remove('hidden');
      wrapper.dataset.playRequested = 'false';
      setState(failed ? 'error' : 'idle');
    };
    const bindVideo = (nextVideo) => {
      if (!nextVideo || nextVideo.dataset.playbackBound) return;
      video = nextVideo;
      nextVideo.dataset.playbackBound = 'true';
      const label = wrapper.dataset.akbarVideoLabel;
      if (label) nextVideo.setAttribute('aria-label', label);
      nextVideo.addEventListener('playing', () => {
        setState('playing');
        if (!nextVideo.requestVideoFrameCallback) requestAnimationFrame(() => requestAnimationFrame(reveal));
      });
      nextVideo.addEventListener('click', () => { if (!nextVideo.paused) nextVideo.pause(); });
      nextVideo.addEventListener('waiting', () => {
        if (wrapper.dataset.playRequested === 'true') setState('loading');
      });
      nextVideo.addEventListener('pause', () => {
        if (wrapper.dataset.playRequested === 'true') reset();
      });
      nextVideo.addEventListener('ended', () => reset());
      nextVideo.addEventListener('error', () => reset(true));
    };
    bindVideo(video);
    const prime = (force = false) => {
      video = video || mountVideo(wrapper);
      bindVideo(video);
      if (!video) return;
      if (wrapper.hasAttribute('data-akbar-unmute-on-play')) video.muted = false;
      if (force || !video.dataset.preloadPrimed) {
        video.dataset.preloadPrimed = 'true';
        video.load();
      }
    };
    button.addEventListener('pointerdown', prime, { passive: true });
    button.addEventListener('click', event => {
      event.preventDefault();
      event.stopPropagation();
      if (wrapper.dataset.playRequested === 'true') return;
      const retry = wrapper.dataset.playbackState === 'error';
      prime(retry);
      if (!video) { reset(true); return; }
      wrapper.dataset.playRequested = 'true';
      setState('loading');
      getScope(wrapper)?.querySelectorAll('video').forEach(other => {
        if (other !== video) other.pause();
      });
      const start = () => {
        if (!video || wrapper.dataset.playRequested !== 'true') return;
        if (video.requestVideoFrameCallback) frameRequest = video.requestVideoFrameCallback(reveal);
        video.play().catch(() => reset(true));
      };
      if (video.readyState >= 2) {
        start();
      } else {
        video.addEventListener('canplay', start, { once: true });
      }
    });
  }

  const initialize = () => document.querySelectorAll('[data-akbar-diary-scope] .video-wrapper, [id^="gallery-"] .video-wrapper').forEach(bind);
  initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
